import axios from 'axios';
import swal from 'sweetalert';

const API_URL = 'https://api.paragaia.tn/user';

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export const adminLogin = async (email, password) => {
  try {
    const response = await axiosInstance.post('/admin-login', { email, password });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 401) {
      await swal("Erreur!", "Échec de la connexion, identifiants incorrects ou vous n'êtes pas un administrateur.", "error");
    } else {
      await swal("Erreur!", "Une erreur est survenue, veuillez essayer à nouveau.", "error");
    }
    throw error;
  }
};

export const getAdminProfile = async () => {
  try {
    const response = await axiosInstance.get('/me');
    return response.data.user;
  } catch (error) {
    throw error;
  }
};

export const getAllClients = async () => {
  try {
    const response = await axiosInstance.get('/clients');
    return response.data;
  } catch (error) {
    await swal("Erreur!", "Impossible de récupérer les clients.", "error");
    throw error;
  }
};


export const getAdminDashboard = async (slug, token) => {
  return axios.get(`https://api.paragaia.tn/user/dashboardadminonly?slug=${slug}`, {
    headers: {
      Authorization: `Bearer ${token}`
    },
    withCredentials: true
  });
};

export const banClient = async (id) => {
  try {
    const response = await axiosInstance.post('/ban-client', { id });
    return response.data;
  } catch (error) {
    await swal("Erreur!", "Impossible de bannir ce client.", "error");
    throw error;
  }
};

export const updateClient = async (id, data) => {
  try {
    const response = await axiosInstance.post('/update-client', { id, ...data });
    return response.data;
  } catch (error) {
    await swal("Erreur!", "Impossible de modifier ce client.", "error");
    throw error;
  }
};

export const deleteClient = async (id) => {
  try {
    const response = await axiosInstance.post('/delete-client', { id });
    return response.data;
  } catch (error) {
    await swal("Erreur!", "Impossible de supprimer ce client.", "error");
    throw error;
  }
};

export const unbanClient = async (id) => {
  try {
    const response = await axiosInstance.post('/unban-client', { id });
    return response.data;
  } catch (error) {
    await swal("Erreur!", "Impossible de débannir ce client.", "error");
    throw error;
  }
};

export const createClientByAdmin = async (email) => {
  try {
    const response = await axiosInstance.post('/add-client', { email });
    return response.data;
  } catch (error) {
    await swal("Erreur!", "Impossible d’ajouter ce client.", "error");
    throw error;
  }
};


export const logoutAdmin = async () => {
  try {
    await axiosInstance.post('/logout');
    localStorage.removeItem('access_token');
    return { message: 'Déconnexion réussie.' };
  } catch (error) {
    throw error;
  }
};
